module.exports = __webpack_public_path__ + "static/media/drugn_nft.2bc51fcb.png";